import { render, staticRenderFns } from "./LifetimeStats.vue?vue&type=template&id=12380c80&scoped=true"
import script from "./LifetimeStats.vue?vue&type=script&lang=js"
export * from "./LifetimeStats.vue?vue&type=script&lang=js"
import style0 from "./LifetimeStats.vue?vue&type=style&index=0&id=12380c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12380c80",
  null
  
)

export default component.exports